<template>
  <!-- 病历打印 -->
  <div class="medicalRecordPrint2">
    <div ref="print5" class="medicalRecordPrint2_body" v-if="info.patientName">
      <div class="mk_title">医嘱禁忌</div>
      <div class="hander">
        <div class="u_row">
          <div class="u_item">
            <span class="label">就诊日期:</span>
            <span class="value">{{ info.visitDateTime || date }}</span>
          </div>
          <div class="u_item"></div>
          <div class="u_item"></div>
        </div>
        <div class="u_row">
          <div class="u_item">
            <span class="label">姓名:</span>
            <span class="value">{{ info.patientName }}</span>
          </div>
          <div class="u_item">
            <span class="label">性别:</span>
            <span class="value">{{ info.gender || info.sex }}</span>
          </div>
          <div class="u_item">
            <span class="label">年龄:</span>
            <span class="value" v-if="info.patientAge">{{ info.patientAge }}岁</span>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="u_row">
          <div class="u_item">
            <span class="value" v-html="taboo || info.taboo"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  props: {
    info: {
      type: Object,
      default: function () {
        return {};
      },
    },
    taboo: {
      type: String,
      default: "",
    },
  },
  computed: {
    date() {
      return dayjs().format("YYYY-MM-DD");
    },
  },
  data() {
    return {};
  },
  methods: {
    print() {
      this.$print(this.$refs.print5);
    },
  },
};
</script>

<style lang="scss" scope>
.medicalRecordPrint2_body {
  width: 100%;
  color: #000;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  background: #fff;
  display: none;
  font-size: 13px;

  .ivu-badge {
    margin: 0 10px 0 0;

    .ivu-badge-body {
      top: -12px !important;
    }

    .ivu-badge-count {
      border-color: #ddd;
    }
  }

  .drugDecoctPattern,
  .drugTakePattern {
    display: none;
  }

  .quantity {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 22px;
    color: #f00;
  }

  .drugs_format {
    font-size: 13px !important;
    width: 100%;
    padding-bottom: 10px;

    .drug {
      flex: 1;
      white-space: nowrap;
      display: inline-block;
      line-height: 1.4em;
    }
  }

  .hander {
    border-bottom: 1px dotted #b20000;
    padding-bottom: 10px;
    margin-bottom: 10px;
  }

  .checkbox_1 {
    display: flex;
    align-items: center;

    span {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .fgx {
      padding: 0 10px;
    }

    i {
      display: inline-block;
      width: 16px;
      height: 16px;
      border: 1px solid #b20000;
      margin-right: 2px;
      position: relative;

      &.check::after {
        content: " ";
        display: inline-block;
        border: 2px solid #b20000;
        border-width: 0 0 2px 2px;
        width: 10px;
        height: 6px;
        transform: rotate(-40deg);
        position: absolute;
        top: 3px;
        left: 2px;
      }
    }
  }

  .mk_title {
    line-height: 40px;
    font-size: 26px;
    text-align: center;
    color: #b20000;
    font-family: 隶书;
  }

  .u_row {
    display: flex;
    justify-content: space-between;
    width: 100%;

    .u_item {
      display: flex;
      .label {
        color: #b20000;
        padding-right: 2px;
      }
    }
  }

  .content {
    min-height: 520px;

    .label {
      width: 64px;
      flex-shrink: 0;
      text-align: right;
    }

    .cf {

      .value,
      .u_item {
        width: 100%;
        position: relative;
      }
    }
  }

  .foot {
    border-top: 1px dotted #b20000;
    padding-bottom: 10px;

    .value {
      width: 120px;
    }
  }
}

.medicalRecordPrint2_show .medicalRecordPrint2_body {
  display: block;
  position: relative;
  background: transparent;
}

@media print {
  .medicalRecordPrint2_body {
    display: block;
    position: absolute;
  }
}
</style>